import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    restorerList: [],
};
const getters = {
    getRestorer: state => state.restorerList

};

const mutations = {
    RESTORER_INFO(state, data) {
        state.restorerList = data
    }
};

const actions = {
    getRestorer({commit}) {
        axiosGet(`crm/restorer/status`).then((response) => {
            commit('RESTORER_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
